<template>
	<view class="box" v-if="info">
		<view class="item">
			<view class="item-a">
				<text class="item-a-num" v-if="info.couponType === 0">{{info.price}}</text>
				<text class="item-a-num1" v-else-if="info.couponType === 1">{{info.price}}</text>
				<text>满{{info.limitPrice}}可用</text>
			</view>
			<view class="item-b">
				<view class="item-b-left">
					<text>{{info.name}}</text>
					<text>{{info.endDate.substring(0, 10)}} 日到期</text>
				</view>
			</view>
		</view>
		<view class="info">
			<view class="info-item">
				<view class="info-item-label">使用时间</view>
				<view class="info-item-val">{{info.endDate.substring(0, 10)}} 日到期</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">适用对象</view>
				<view class="info-item-val">{{info.relationInfoList ? info.relationInfoList.join('、') : ''}}</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">使用说明</view>
				<view class="info-item-val">{{info.info}}</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				info: null
			};
		},
		onLoad(option) {
			this.id = option.id
			this.getDetails()
		},
		methods: {
			getDetails() {
				this.$u.api.memberCouponDetail({ id: this.id })
					.then(res => {
						if (res.code === 200) {
							console.log(res)
							this.info = res.data
						}
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 30rpx;
		box-sizing: border-box;
		.info {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 18rpx;
			.info-item {
				width: 100%;
				padding: 30rpx 0;
				box-sizing: border-box;
				border-bottom: 1rpx solid #E5E5E5;
				&:last-child {
					border-bottom: none !important;
				}
				.info-item-label {
					font-weight: 500;
					font-size: 32rpx;
					color: #111111;
				}
				.info-item-val {
					font-weight: 400;
					font-size: 28rpx;
					color: #777777;
					margin-top: 24rpx;
					line-height: 45rpx;
				}
			}
		}
		.item {
			width: 100%;
			height: 170rpx;
			display: flex;
			align-items: center;
			background: #FFEFEF;
			border-radius: 16rpx;
			margin-bottom: 20rpx;
			&:last-child {
				margin: 0 !important;
			}
			.item-a {
				width: 208rpx;
				height: 100%;
				flex-shrink: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				border-right: 1rpx dashed #E3C1C1;
				.item-a-num {
					font-weight: 600;
					font-size: 44rpx;
					color: #E4001D;
					&::before {
						content: '￥';
						font-weight: 600;
						font-size: 24rpx;
						color: #E4001D;
					}
				}
				.item-a-num1 {
					font-weight: 600;
					font-size: 44rpx;
					color: #E4001D;
					&::after {
						content: '折';
						font-weight: 600;
						font-size: 24rpx;
						color: #E4001D;
					}
				}
				text {
					font-weight: 400;
					font-size: 24rpx;
					color: #E93047;
					margin-top: 8rpx;
				}
			}
			.item-b {
				flex: 1;
				padding: 0 30rpx;
				box-sizing: border-box;
				height: 100%;
				display: flex;
				align-items: center;
				.item-b-left {
					flex: 1;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 32rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 24rpx;
							color: #777777;
							margin-top: 12rpx;
						}
					}
				}
			}
		}
	}
</style>